import type { PhotoTransform } from '@jobos/shared';
import { clampPanOffset } from './inspectionDocument';

// Geometry for the photo navigator (minimap). The slot photo is rendered
// `translate(offset·100%) scale(zoom)` about center, so the part visible in the
// slot maps exactly into slot-fraction coordinates [0, 1] — no image-pixel math.

export interface ViewportRect {
  /** Top-left of the visible window, as a fraction of the photo frame. */
  left: number;
  top: number;
  /** Side length of the visible window, as a fraction (1/zoom per axis). */
  size: number;
}

// Where the slot's visible window sits over the whole photo, for the given transform.
export function viewportFromTransform({ zoom, offsetX, offsetY }: PhotoTransform): ViewportRect {
  return {
    size: 1 / zoom,
    left: 0.5 - (0.5 + offsetX) / zoom,
    top: 0.5 - (0.5 + offsetY) / zoom,
  };
}

// Inverse: given the viewport box's top-left (fraction), recover the clamped pan
// offsets. Used while dragging the box in the navigator.
export function offsetFromViewportTopLeft(left: number, top: number, zoom: number): { offsetX: number; offsetY: number } {
  return {
    offsetX: clampPanOffset(zoom * (0.5 - left) - 0.5, zoom),
    offsetY: clampPanOffset(zoom * (0.5 - top) - 0.5, zoom),
  };
}
